import type { RouteObject } from 'react-router';
import { Link } from 'react-router';
import { Card, Notice } from '@/ui/core';
import { StaffHome } from '@/features/home/StaffHome';
import { AreaCount } from '@/features/count/AreaCount';
import { GunsPage } from '@/features/count/GunsPage';
import { MovesPage } from '@/features/count/MovesPage';

function NotFound() {
  return (
    <div className="mx-auto max-w-lg">
      <Card>
        <Notice tone="info" title="Page not found">
          That address doesn’t exist in this app.
        </Notice>
        <Link to="/" className="mt-4 inline-block font-semibold text-accent underline">
          Back to the home screen
        </Link>
      </Card>
    </div>
  );
}

const admin = <T extends string>(path: string, load: () => Promise<Record<T, React.ComponentType>>, name: T): RouteObject => ({ path, lazy: () => load().then((m) => ({ Component: m[name] })) });

export const routes: RouteObject[] = [
  { index: true, element: <StaffHome /> },
  { path: 'count/:date/:area', element: <AreaCount /> },
  { path: 'guns/:date', element: <GunsPage /> },
  { path: 'promo/:date', element: <MovesPage mode="promo" /> },
  { path: 'brought/:date', element: <MovesPage mode="brought" /> },
  { path: 'admin/moves', element: <MovesPage /> },
  { path: 'admin/moves/:date', element: <MovesPage /> },
  admin('admin', () => import('@/features/admin/AdminHome'), 'AdminHome'),
  admin('admin/nights', () => import('@/features/admin/NightsPage'), 'NightsPage'),
  admin('admin/night/:date', () => import('@/features/admin/NightReview'), 'NightReview'),
  admin('admin/week', () => import('@/features/admin/WeekPage'), 'WeekPage'),
  admin('admin/items', () => import('@/features/admin/ItemsPage'), 'ItemsPage'),
  admin('admin/order', () => import('@/features/admin/OrderPage'), 'OrderPage'),
  admin('admin/trends', () => import('@/features/admin/TrendsPage'), 'TrendsPage'),
  admin('admin/specials', () => import('@/features/admin/SpecialsPage'), 'SpecialsPage'),
  admin('admin/people', () => import('@/features/admin/PeoplePage'), 'PeoplePage'),
  admin('admin/data', () => import('@/features/admin/DataPage'), 'DataPage'),
  admin('admin/history', () => import('@/features/admin/HistoryPage'), 'HistoryPage'),
  admin('admin/feedback', () => import('@/features/admin/FeedbackPage'), 'FeedbackPage'),
  admin('help', () => import('@/help/GuidePage'), 'GuideIndex'),
  admin('help/:topicId', () => import('@/help/GuidePage'), 'GuideTopic'),
  { path: '*', element: <NotFound /> },
];
